import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../../api/AccountsAPI/verifyShareCreationAPI';

const err = (e, fallback) => e?.ErrorDetails?.ErrorMessage || e?.Message || e?.message || fallback;

export const fetchShareCreationQueue = createAsyncThunk(
    'verifyShareCreation/fetchQueue',
    async (roleId, { rejectWithValue }) => {
        try { return await api.getVerifyShareCreationGrid(roleId); }
        catch (e) { return rejectWithValue(err(e, 'Failed to fetch share detail verification queue')); }
    }
);

export const fetchShareCreationDetail = createAsyncThunk(
    'verifyShareCreation/fetchDetail',
    async (refNo, { rejectWithValue }) => {
        try { return await api.getVerifyShareCreationView(refNo); }
        catch (e) { return rejectWithValue(err(e, 'Failed to fetch share details')); }
    }
);

export const submitApproveShareCreation = createAsyncThunk(
    'verifyShareCreation/approve',
    async (payload, { rejectWithValue }) => {
        try { return await api.approveShareCreation(payload); }
        catch (e) { return rejectWithValue(err(e, 'Error Occurred While Verification')); }
    }
);

const initialState = {
    queue: [], queueLoading: false, queueError: null,
    detail: null, detailLoading: false, detailError: null,
    verifyLoading: false,
};

const verifyShareCreationSlice = createSlice({
    name: 'verifyShareCreation',
    initialState,
    reducers: {
        clearShareCreationDetail: (s) => { s.detail = null; s.detailError = null; s.detailLoading = false; },
        resetVerifyShareCreation: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchShareCreationQueue.pending, (s) => { s.queueLoading = true; s.queueError = null; })
            .addCase(fetchShareCreationQueue.fulfilled, (s, a) => { s.queueLoading = false; s.queue = a.payload?.Data || []; })
            .addCase(fetchShareCreationQueue.rejected, (s, a) => { s.queueLoading = false; s.queueError = a.payload; s.queue = []; });

        builder
            .addCase(fetchShareCreationDetail.pending, (s) => { s.detailLoading = true; s.detailError = null; s.detail = null; })
            .addCase(fetchShareCreationDetail.fulfilled, (s, a) => { s.detailLoading = false; s.detail = a.payload?.Data || null; })
            .addCase(fetchShareCreationDetail.rejected, (s, a) => { s.detailLoading = false; s.detailError = a.payload; s.detail = null; });

        builder
            .addCase(submitApproveShareCreation.pending, (s) => { s.verifyLoading = true; })
            .addCase(submitApproveShareCreation.fulfilled, (s) => { s.verifyLoading = false; })
            .addCase(submitApproveShareCreation.rejected, (s) => { s.verifyLoading = false; });
    },
});

export const { clearShareCreationDetail, resetVerifyShareCreation } = verifyShareCreationSlice.actions;

export const selectVSRQueue = (s) => s.verifyShareCreation.queue;
export const selectVSRQueueLoading = (s) => s.verifyShareCreation.queueLoading;
export const selectVSRQueueError = (s) => s.verifyShareCreation.queueError;
export const selectVSRDetail = (s) => s.verifyShareCreation.detail;
export const selectVSRDetailLoading = (s) => s.verifyShareCreation.detailLoading;
export const selectVSRDetailError = (s) => s.verifyShareCreation.detailError;
export const selectVSRVerifyLoading = (s) => s.verifyShareCreation.verifyLoading;

export default verifyShareCreationSlice.reducer;
